export default {
  inspirations: 'Inspiration',
  gifts: 'Gifts',
  occasions: 'Occasions',
  'tutorials-and-advices': 'Tips and tutorials',
  'home-furnishing': 'Home decor',
  highlights: 'Highlights',
}
